import { Helmet } from "react-helmet";
import CareersLayout from "../sections/careers/careersLayout";

const CareersPage = () => {
    return (
        <>
            <Helmet>
                <title>Careers at code3x | Join Our AI, Gaming & Digital Team</title>
                <meta name="description" content="Build your future with code3x. Explore career opportunities in AI, game development, and digital innovation." />
                <meta name="keywords" content="code3x jobs, careers in AI, game development careers, digital solutions jobs, join code3x, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/careers" />
            </Helmet>

            <CareersLayout />
        </>
    );
}

export default CareersPage;